module.exports = __webpack_public_path__ + "static/img/14.6804eed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/14.png
// module id = KKZ9
// module chunks = 0